import {DateTime} from "luxon";

export default function age(timestamp: number | null) {
	if (!timestamp) {
		return "";
	}
	const date = DateTime.fromSeconds(timestamp);
	return Math.floor(Math.abs(date.diff(DateTime.local(), "years").years));
}
